const headerImages = [
  '/images/header/B4IT_header_1.jpg',
];

export default {
  template: `
       <img v-parallax="0.1" v-bind:src="displayedImage" alt="" width="1120" height="560">
    `,
  data: function () {
    return {
      displayedImage: headerImages[randomIntWithinRange(0, headerImages.length - 1)]
    }
  }
};

function randomIntWithinRange(min,max) {
  return Math.floor(Math.random()*(max-min+1)+min);
}



// WEBPACK FOOTER //
// ./src/js/components/header-image.component.js